import React from "react";
import { useNavigate } from "react-router-dom";
import GridCard from "../components/GridCard.jsx";

export default function Home() {
    const nav = useNavigate();

    // Serien mit Aktiv-Status
    const cards = [
        {
            title: "Season 1",
            sub: "Sprint Saison",
            to: "/gt3x/overview",
            img: "/landing/GT3X-Liga-Logo.png",
            active: true
        },
        {
            title: "TBA",
            sub: "Endurance",
            to: "/gtex/OverviewGTEX",
            img: "/landing/EnduX-Liga-Logo.png",
            active: false
        },
        {
            title: "TBA",
            sub: "TBA",
            to: "/gt4x/overview",
            img: "/landing/GT4X-Liga-Logo.png",
            active: false
        },
        {
            title: "TBA",
            sub: "TBA",
            to: "/specialx/overview",
            img: "/landing/SpecialX-Liga-Logo.png",
            active: false
        },
    ];

    return (
        <>
            <div className="card card--accent">
                <h1>Willkommen beim RACEVISION Liga Manager</h1>
                <p>
                    Aktuell steht eine Serie zur Auswahl, die wir anbieten.
                    Wir wollen im Laufe der Zeit gerne weitere hinzufügen,
                    jedoch erst einmal die Abläufe verfestigen.
                </p>
            </div>

            <div className="grid4">
                {cards.map(c => (
                    <div
                        key={c.title}
                        className={`card-series-wrapper ${!c.active ? "card-series--inactive" : ""}`}
                        onClick={() => c.active && nav(c.to)}
                    >
                        <GridCard {...c} />
                    </div>
                ))}
            </div>
        </>
    );
}
